import { jsx as _jsx } from "react/jsx-runtime";
import AdminPageLayout from '../../../layout/admin-page-layout';
import { adminRoutes } from '../../../common/routes/admin';
import { DiscussionDetail } from '../../_shared/discussions';
function AdminDiscussionDetail(props) {
    return (_jsx(AdminPageLayout, { children: _jsx(DiscussionDetail, { discussionId: props.id, baseUrl: adminRoutes.discussions.getURL() }) }));
}
export default AdminDiscussionDetail;
